// 获取稿件详情
import axios from "@/utils/request.js";
export const getManuscript = ({ id, type }) => {
    const _url = `/api/web-content/manuscript/manager/detail/?webMsId=${id}`;
    return axios.get(_url);
};